import { Component, Vue, Watch as watch} from 'nuxt-property-decorator';
import {mapGetters} from 'vuex';

@Component({
    components: {
        offers: require('@/components/catalog/offer-horisontal-slider/').default,
        recentViewList: require('~/components/catalog/recent-view-list').default,
    },
    computed: mapGetters(['region']),
    breadcrumbs: [{name: 'Каталог'}],
})
export default class RootCatalogPageComponent extends Vue {

    private lists: OfferList[] = [];
    private metaData = null;

    private head() {
        return {
            title: this.metaData.title,
            meta: [
                { vmid: 'description', name: 'description', content: this.metaData.description }
            ]
        }
    }

    private async asyncData({store}) {
        const data = await store.dispatch('catalog/ShortedCatalog', {
            id: 0,
        });

        return {
            lists: data.lists,
            metaData: data.meta,
        };
    }

    @watch('region')
    private async onRegionChange() {

        const data = await this.$store.dispatch('catalog/ShortedCatalog', {
            id: 0,
        });

        this.lists = data.lists;
        this.metaData = data.meta;
    }
}
